import * as React from "react";
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider,
  useLocation,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";
import "./global.css";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enJSON from "./locale/en.json";
import jaJSON from "./locale/ja.json";
import ReactGA from "react-ga4";

import FrontPage from "./pages/FrontPage";
import IssueCard from "./pages/issuecard";
import NativeCard from "./pages/nativecard";
import Compatibility from "./pages/compatibility";
import Matched from "./pages/matched";
import Reset from "./pages/reset";
import TermsAndConditions from "./pages/terms";
import PrivacyPolicy from "./pages/privacy";
import Tokushoho from "./pages/tokushoho";
import SelfMatching from "./pages/selfmatching";
import Ranking from "./pages/ranking";
import Layout from "./components/Layout";
import PictureBook from "./pages/picturebook";
import SocialGraph from "./pages/socialgraph";

import * as Sentry from "@sentry/react";
import PictureBookNoFriendsFallback from "./pages/picturebook/picturebookNoFriendsFallback";
import Community from "./pages/community";
import Characters from "./pages/characters";
import CharactersCreate from "./pages/characterscreate";
import CharactersSingle from "./pages/characterssingle";
import CharactersSeeAll from "./pages/charactersseeall";
import Profile from "./pages/profile";
import CommunityCreate from "./pages/communitycreate";
import CommunitySingle from "./pages/communitysingle";
import ThreadCreate from "./pages/threadscreate";
import ThreadSingle from "./pages/threadSingle";
import CommunitiesSeeAll from "./pages/communitiesseeall";
import UserPageWithCommunity from "./pages/userpagewithcommunity";
import Astrology from "./pages/astrology";
import Home from "./pages/home";
import HomeCategoryArticle from "./pages/homecategoryarticle";
import Invite from "./pages/invite";
import InviteCompatibility from "./pages/invitecompatibility";
import ScoreLink from "./pages/scorelink";
import RankingRedirect from "./pages/rankingRedirect";
import CSAEPolicy from "./pages/csaepolicy";
import LineLogin from "./pages/lineLogin";
import DeleteUser from "./pages/deleteme";
import Contact from "./pages/contactus";
import Character from "./pages/character";
import CharacterCompatibility from "./pages/charactercompatibility";
import LoginPage from "./pages/adminLogin";
import Dashboard from "./pages/adminNotifications";
import AdminDashboardLayout from "./pages/adminDashboard/adminDashboard";
import QuizManagement from "./pages/quizManagement/quizManagement";
import QuizForm from "./pages/quizManagement/quizForm";
import QuizPreview from "./pages/quizManagement/quizPreview";
import MegaQuizManagement from "./pages/megaquizManagement/megaquizManagement";
import MegaQuizForm from "./pages/megaquizManagement/megaquizForm";
import MegaQuizPreview from "./pages/megaquizManagement/megaquizPreview";
import {
  ProjectManagement,
  ProjectReview,
} from "./pages/projctManagement/adminProjectManagement";
import { NotificationProvider } from "./pages/adminProjectNotifications/popupnotifications";
import ProductManagement from "./pages/adminProductManagement";
import EventTicketScanner from "./pages/EventTicketScanner";
import EmailVerification from "./pages/EmailVerification";
// import ProductCouponManagement from "./pages/adminProductManagement/ProductCouponManagement";
import IdeasBannerManagement from "./pages/projctManagement/ideasBannerManagement";
import Events from "./pages/Events";
import EventsNTTDATA from "./pages/Events/Success/otaXnttData";
import EventLogin from "./pages/EventLogin";
import Success from "./pages/Events/Success";
import OAuthCallback from "./components/OAuthCallback";
import { GoogleOAuthProvider } from "@react-oauth/google";
import EventCheckout from "./pages/Events/EventCheckout";
import GlobalBannerManagement from "./pages/GlobalBannerManagement";
import { initMetaPixel, trackPageView } from "./components/metaPixel/metaPixel";
import CouponSelectionPage from "./pages/adminProductManagement/ProductCouponManagement/CouponManagementSelection";
import SingleUseCouponManagement from "./pages/adminProductManagement/ProductCouponManagement";
import CampaignCouponManagement from "./pages/adminProductManagement/ProductCouponManagement/CampaignCouponManagement";
import AddOnEventActivityManangementPage from "./pages/adminProductManagement/ActivityManangement/AddOnEventActivityManagementPage";
import ProductAddOnPasses from "./pages/adminProductManagement/ActivityManangement/AddOnEventPasses";
import TicketResolution from "./pages/ticketResolution";
import ProductWorkspace from "./pages/adminProductManagement/productWorkspace";
import AdminOverview from "./pages/adminOverview";
import ShopfrontManagement from "./pages/adminShopfrontManagement";
import ShopfrontWorkspace from "./pages/adminShopfrontManagement/ShopfrontWorkspace";
import UserManagement from "./pages/AdminUserManagement";
import UserWorkspace from "./pages/AdminUserManagement/userWorkspace";
import CreateProduct from "./pages/adminProductManagement/createProduct";
import ShopOwnerLogin from "./pages/shopOwner/Login";
import ShopDashboard from "./pages/shopOwner/Dashboard";
import ShopOwnerLayout from "./pages/shopOwner/ShopOwnerLayout";
import ShopInventory from "./pages/shopOwner/Inventory";
import ShopProductFormWrapper from "./pages/shopOwner/ProductForm";
import ShopWrapper from "./pages/shopOwner/ShopWrapper";
import ShopList from "./pages/shopOwner/ShopList";
import ShopWorkspace from "./pages/shopOwner/ShopWorkspace";
import GlobalProductList from "./pages/shopOwner/GlobalProductList";
import AnalyticsDashboard from "./pages/AdminAnalyticsDashboard/AnalyticsDashboard";
import MegaQuizBannerConfig from "./pages/megaquizManagement/megaquizBannerConfig";
import MegaQuizLeaderboard from "./pages/megaquizManagement/megaquizLeaderboard";
import FeedsManagement from "./pages/AdminFeedsManagement/FeedsManagement";
import ReferralLandingPage from "./pages/ReferralInvite";
import { EditProjectPage } from "./pages/projctManagement/editProjectModal";
import MerchantOnboarding from "./pages/shopOwner/Onboarding/MerchantOnboarding";
import BoothApplicationReview from "./pages/EventsManagement/BoothApplicationReview";
import CreatorApplicationsReview from "./pages/CreatorApplications/CreatorApplicationsReview";
import CommunityManagementReview from "./pages/CommunityManagement/CommunityManagementReview";
import EarningsSettlementReview from "./pages/CommunityManagement/EarningsSettlementReview";
import UgcModerationReview from "./pages/UgcModeration/UgcModerationReview";
import AuditLogPage from "./pages/AuditLog/AuditLogPage";
import ShopCustomerLayout from "./pages/ShopCustomer/ShopCustomerLayout";
import ShopScope from "./pages/ShopCustomer/ShopScope";
import ShopCustomerLogin from "./pages/ShopCustomer/Login";
import ShopCustomerOnboarding from "./pages/ShopCustomer/Onboarding";
import ActiveShops from "./pages/ShopCustomer/ActiveShops";
import ShopHome from "./pages/ShopCustomer/ShopHome";
import ProductDetail from "./pages/ShopCustomer/ProductDetail";
import CartPreview from "./pages/ShopCustomer/CartPreview";
import Checkout from "./pages/ShopCustomer/Checkout";
import OrderConfirmation from "./pages/ShopCustomer/OrderConfirmation";
import ShopCustomerProfile from "./pages/ShopCustomer/Profile";
import ShopCustomerOrderDetail from "./pages/ShopCustomer/OrderDetail";
const RequireAdminAuth = ({ children }) => {
  const isAdmin = localStorage.getItem("IS_ADMIN");
  return isAdmin ? children : <Navigate to="/admin" />;
};

const RequireShopOwnerAuth = ({ children }) => {
  const token = localStorage.getItem("shopToken");
  return token ? children : <Navigate to="/shop-owner/login" />;
};

const RequireShopCustomerAuth = ({ children }) => {
  const token = localStorage.getItem("JWTtoken");
  const location = useLocation();
  return token ? (
    children
  ) : (
    <Navigate to="/shop/login" state={{ from: location.pathname }} replace />
  );
};

const AppWrapper = () => {
  const location = useLocation();
  ReactGA.initialize("G-HQVKZF94MW");
  React.useEffect(() => {
    initMetaPixel();
  }, []);
  React.useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
    });
    trackPageView();
  }, [location]);
  return (
    <div>
      <Outlet />
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppWrapper />,
    children: [
      {
        path: "/",
        element: <FrontPage />,
      },
      {
        path: "/invite",
        element: (
          <GoogleOAuthProvider
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
          >
            <ReferralLandingPage />
          </GoogleOAuthProvider>
        ),
      },
      {
        // Old Native login (dead auth.be-native.life); send people to the front page
        path: "/login",
        element: <Navigate to="/" replace />,
      },
      // {
      //   path: "/invite/:userId",
      //   element: <Invite />,
      // },
      {
        path: "/character/:characterId",
        element: <Character />,
      },
      {
        path: "/characterCompatibility/:userId/:characterId",
        element: <CharacterCompatibility />,
      },
      {
        path: "/delete-me",
        element: <DeleteUser />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/lineLogin/:code",
        element: <LineLogin />,
      },
      // {
      //   path: "/invite/:userId/:reffId",
      //   element: <InviteCompatibility />,
      // },
      {
        path: "/score/:userId/:quizId",
        element: <ScoreLink />,
      },
      {
        path: "/rankingRedirect/:quizId",
        element: <RankingRedirect />,
      },
      {
        path: "/rankingRedirect",
        element: <RankingRedirect />,
      },
      {
        path: "/home",
        element: (
          <Layout>
            <Home />
          </Layout>
        ),
      },
      {
        path: "/home/:categoryId/:documentId",
        element: (
          <Layout>
            <HomeCategoryArticle />
          </Layout>
        ),
      },
      {
        path: "/home/:id",
        element: (
          <Layout>
            <Home />
          </Layout>
        ),
      },
      {
        path: "/issue-card",
        element: <IssueCard />,
      },
      {
        path: "/native-card",
        element: (
          <Layout>
            <NativeCard />
          </Layout>
        ),
      },
      {
        path: "/native-card/:name/:year/:month/:day",
        element: (
          <Layout>
            <NativeCard isCustom />
          </Layout>
        ),
      },
      {
        path: "/compatibility/:userId/:referrerId",
        element: (
          <Layout>
            <Compatibility />
          </Layout>
        ),
      },
      {
        path: "/matched",
        element: (
          <Layout>
            <Matched />
          </Layout>
        ),
      },
      {
        path: "/reset",
        element: <Reset />,
      },
      {
        path: "/terms-and-conditions",
        element: (
          <Layout>
            <TermsAndConditions />
          </Layout>
        ),
      },
      {
        path: "/privacy-policy",
        element: (
          <Layout>
            {" "}
            <PrivacyPolicy />
          </Layout>
        ),
      },
      {
        path: "/csae-policy",
        element: (
          <Layout>
            {" "}
            <CSAEPolicy />
          </Layout>
        ),
      },
      {
        path: "/tokushoho",
        element: (
          <Layout>
            {" "}
            <Tokushoho />
          </Layout>
        ),
      },
      {
        path: "/self-matching",
        element: (
          <Layout>
            <SelfMatching />
          </Layout>
        ),
      },
      {
        path: "/email-verification/:verificationToken",
        element: (
          <Layout>
            <EmailVerification />
          </Layout>
        ),
      },
      {
        path: "/compatibility/:userId/:name/:year/:month/:day",
        element: (
          <Layout>
            <Compatibility isSingleSelfMatchingType />
          </Layout>
        ),
      },
      {
        path: "/characters/compatibility/:userId/:name/:year/:month/:day/:charId",
        element: (
          <Layout>
            <Compatibility isSingleSelfMatchingType isCharacterType />
          </Layout>
        ),
      },
      {
        path: "/compatibility/:name/:year/:month/:day/:name2/:year2/:month2/:day2",
        element: (
          <Layout>
            <Compatibility isDoubleSelfMatchingType />
          </Layout>
        ),
      },
      {
        path: "/ranking",
        element: (
          <Layout>
            <Ranking />
          </Layout>
        ),
      },
      {
        path: "/picture-book",
        element: (
          <Layout>
            <PictureBook />
          </Layout>
        ),
      },
      {
        path: "/social-graph",
        element: (
          <Layout>
            <SocialGraph />
          </Layout>
        ),
      },
      {
        path: "/picture-book-no-friends",
        element: (
          <Layout>
            <PictureBookNoFriendsFallback />
          </Layout>
        ),
      },
      {
        path: "/community",
        element: (
          <Layout>
            <Community />
          </Layout>
        ),
      },
      {
        path: "/community-create",
        element: (
          <Layout>
            <CommunityCreate />
          </Layout>
        ),
      },
      {
        path: "/community/:key",
        element: (
          <Layout>
            <CommunitySingle />
          </Layout>
        ),
      },
      {
        path: "/community/thread/:key/:id",
        element: (
          <Layout>
            <ThreadSingle />
          </Layout>
        ),
      },
      {
        path: "/thread-create/:key",
        element: (
          <Layout>
            <ThreadCreate />
          </Layout>
        ),
      },
      {
        path: "/characters",
        element: (
          <Layout>
            <Characters />
          </Layout>
        ),
      },
      {
        path: "/characters/create",
        element: (
          <Layout>
            <CharactersCreate />
          </Layout>
        ),
      },
      {
        path: "/characters/:charId",
        element: (
          <Layout>
            <CharactersSingle />
          </Layout>
        ),
      },
      {
        path: "/characters/:categoryKey/:categoryTitle/:categorySelected",
        element: (
          <Layout>
            <CharactersSeeAll />
          </Layout>
        ),
      },

      {
        path: "/community/:categoryKey/:categoryTitle/:categorySelected",
        element: (
          <Layout>
            <CommunitiesSeeAll />
          </Layout>
        ),
      },
      {
        path: "/astrology",
        element: (
          <Layout>
            <Astrology />
          </Layout>
        ),
      },
      {
        path: "/profile",
        element: (
          <Layout>
            <Profile />
          </Layout>
        ),
      },
      {
        path: "/user-profile/:userId",
        element: (
          <Layout>
            <UserPageWithCommunity />
          </Layout>
        ),
      },
      {
        path: "*",
        element: <FrontPage />,
      },
    ],
  },
  {
    path: "/ticket-resolution",
    element: <TicketResolution />,
  },
  {
    path: "/events",
    element: <AppWrapper />,
    children: [
      {
        path: "login",
        element: (
          <GoogleOAuthProvider
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
          >
            <EventLogin />
          </GoogleOAuthProvider>
        ),
      },
      {
        path: ":eventId",
        element: <Events />,
      },
      {
        path: "otaXNTTData/:eventId",
        element: <EventsNTTDATA />,
      },
      {
        path: "auth/callback",
        element: <OAuthCallback />,
      },
      // Public: checkout asks for login at Pay, the confirmation page asks when needed
      {
        path: "checkout",
        element: <EventCheckout />,
      },
      {
        path: "order-confirmed",
        element: <Success />,
      },
    ],
  },

  {
    path: "/shop-owner",
    element: <ShopWrapper />,
    children: [
      {
        path: "login",
        element: (
          <GoogleOAuthProvider
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
          >
            <ShopOwnerLogin />
          </GoogleOAuthProvider>
        ),
      },

      {
        path: "",
        element: (
          <RequireShopOwnerAuth>
            <ShopOwnerLayout />
          </RequireShopOwnerAuth>
        ),
        children: [
          {
            index: true,
            element: <Navigate to="dashboard" replace />,
          },
          {
            path: "onboarding",
            element: <MerchantOnboarding />,
          },

          {
            path: "dashboard",
            element: <ShopDashboard />,
          },

          {
            path: "shops",
            element: <ShopList />,
          },
          {
            path: "shops/:shopId",
            element: <ShopWorkspace />,
          },

          {
            path: "products",
            element: <GlobalProductList />,
          },

          {
            path: "products/new",
            element: <ShopProductFormWrapper mode="create" />,
          },
          {
            path: "products/edit/:productId",
            element: <ShopProductFormWrapper mode="edit" />,
          },

          {
            path: "shops/:shopId/product/new",
            element: <ShopProductFormWrapper mode="create" />,
          },
          {
            path: "shops/:shopId/product/edit/:productId",
            element: <ShopProductFormWrapper mode="edit" />,
          },
        ],
      },
    ],
  },
  {
    path: "/admin",
    children: [
      {
        path: "",
        element: <LoginPage />,
      },
      {
        path: "dashboard",
        element: (
          <RequireAdminAuth>
            <AdminDashboardLayout />
          </RequireAdminAuth>
        ),
        children: [
          {
            index: true,
            element: <AdminOverview />,
          },
          {
            path: "events/applications",
            element: <BoothApplicationReview />,
          },
          {
            path: "creator-applications",
            element: <CreatorApplicationsReview />,
          },
          {
            path: "community-management",
            element: <CommunityManagementReview />,
          },
          {
            path: "hub-earnings",
            element: <EarningsSettlementReview />,
          },
          {
            path: "ugc-reports",
            element: <UgcModerationReview />,
          },
          {
            path: "audit-log",
            element: <AuditLogPage />,
          },
          {
            path: "feeds",
            element: <FeedsManagement />,
          },
          {
            path: "analytics",
            element: <AnalyticsDashboard />,
          },
          {
            path: "marketing/notifications",
            element: <Dashboard />,
          },

          {
            path: "users",
            children: [
              {
                path: "",
                element: <UserManagement />,
              },
              {
                path: ":id",
                element: <UserWorkspace />,
              },
            ],
          },

          {
            path: "quiz-management",
            children: [
              {
                path: "",
                element: <QuizManagement />,
              },
              {
                path: "new",
                element: <QuizForm />,
              },
              {
                path: "edit/:id",
                element: <QuizForm />,
              },
              {
                path: "preview/:id",
                element: <QuizPreview />,
              },
            ],
          },
          {
            path: "mega-quiz-management",
            children: [
              {
                path: "",
                element: <MegaQuizManagement />,
              },
              {
                path: "banner-config",
                element: <MegaQuizBannerConfig />,
              },
              {
                path: "new",
                element: <MegaQuizForm />,
              },
              {
                path: "leaderboard/:quizId",
                element: <MegaQuizLeaderboard />,
              },
              {
                path: "edit/:id",
                element: <MegaQuizForm />,
              },
              {
                path: "preview/:id",
                element: <MegaQuizPreview />,
              },
            ],
          },
          {
            path: "project-management",
            children: [
              {
                path: "",
                element: <ProjectManagement />,
              },
              {
                path: "review/:id",
                element: <ProjectReview />,
              },
              {
                path: "edit/:id",
                element: <EditProjectPage />,
              },
              {
                path: "ideas-banner-management",
                element: <IdeasBannerManagement />,
              },
            ],
          },
          {
            path: "product-management",
            children: [
              {
                path: "",
                element: <ProductManagement />,
              },
              {
                path: "manage/:id",
                element: <ProductWorkspace />,
              },
              {
                path: "create",
                element: <CreateProduct />,
              },
              {
                path: "shopfronts",
                children: [
                  { path: "", element: <ShopfrontManagement /> },
                  { path: ":id", element: <ShopfrontWorkspace /> },
                ],
              },

              {
                path: "new",
                element: <div>Create Product Page (Coming Soon)</div>,
              },
            ],
          },
          {
            path: "global-banner-management",
            element: <GlobalBannerManagement />,
          },
        ],
      },
    ],
  },
  {
    path: "/event-scanner",
    element: <EventTicketScanner />,
  },
  {
    path: "/shop",
    element: <ShopCustomerLayout />,
    children: [
      {
        path: "login",
        element: (
          <GoogleOAuthProvider
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
          >
            <ShopCustomerLogin />
          </GoogleOAuthProvider>
        ),
      },
      {
        path: "onboarding",
        element: (
          <RequireShopCustomerAuth>
            <ShopCustomerOnboarding />
          </RequireShopCustomerAuth>
        ),
      },
      {
        path: "shops",
        element: (
          <RequireShopCustomerAuth>
            <ActiveShops />
          </RequireShopCustomerAuth>
        ),
      },
      {
        path: "profile",
        element: (
          <RequireShopCustomerAuth>
            <ShopCustomerProfile />
          </RequireShopCustomerAuth>
        ),
      },
      {
        path: "profile/orders/:orderId",
        element: (
          <RequireShopCustomerAuth>
            <ShopCustomerOrderDetail />
          </RequireShopCustomerAuth>
        ),
      },
      {
        path: ":shopId",
        element: <ShopScope />,
        children: [
          { index: true, element: <ShopHome /> },
          { path: "product/:productId", element: <ProductDetail /> },
          { path: "cart", element: <CartPreview /> },
          { path: "checkout", element: <Checkout /> },
          { path: "order-confirmed/:orderId", element: <OrderConfirmation /> },
        ],
      },
    ],
  },
]);

var userLang = navigator.language || navigator.userLanguage;

i18n.use(initReactI18next).init({
  resources: {
    en: { ...enJSON },
    ja: { ...jaJSON },
  },
  lng: userLang?.includes("en") ? "en" : "ja",
  fallbackLng: "en",
});

// Sentry sends only when REACT_APP_SENTRY_DSN is set at build time (our own project).
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
Sentry.init({
  dsn: sentryDsn,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: Boolean(sentryDsn),
});

ReactDOM.createRoot(document.getElementById("root"), {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <NotificationProvider>
    <RouterProvider router={router} />
  </NotificationProvider>,
);
